<template>

  <v-card outlined :loading="isLoading" >

      <v-card-title>
        <lang t="BUNDLE-DIMENSION-HISTOGRAM"></lang>
        <v-select
          v-model="typeSelected"
          :items="['width', 'height', 'length', 'weight']"
          dense
          flat
          hide-details
          height="20"
          @change="onChangeType"
          style="max-width: 80px; margin-left: auto;">
        </v-select>
      </v-card-title>

      <v-card-text v-if="!isLoading">
          <apexchart :key="stats.series" height='480px'   :options="stats.options" :series="stats.series"></apexchart>
      </v-card-text>

  </v-card>

</template>

<script>
// https://apexcharts.com/vue-chart-demos/
import VueApexCharts from 'vue-apexcharts'
import {cloneDeep} from 'lodash';

export default {
    name: "historyBundleChart",
    components: {
        apexchart: VueApexCharts
    },

    props: {

      bundle: {
      type: Object,
    },

        show: {
          type: Boolean,
          default: false
        }

    },

    data: function() {

        return {

            typeSelected: 'width',
            isLoading: true,
            bundleAttributeValue: 0,
            bundleAttributeDisplayName: 'width',
            statsData: null,
            multiscanData: {},
            measurementData: {},

            stats: {
                series: [{
                    data: []
                }],
                
                options: {
                    chart: {
                        type: 'scatter',
                    },
                    legend: {
                      showForSingleSeries: true,
                      labels: {
                        useSeriesColors: true,
                        show: true

                      },
                    },
                    grid: {
                      row: {
                        colors: ['#fff', '#f5f5f5']
                      },
                    },
                    xaxis: {
                      type: 'datetime',
                      labels: {
                        format: 'dd/MM/yyyy',
                        show: true,
                      },
                    },
                    yaxis: {
                      tickAmount: 7,
                    },
                    annotations:{
                      
                    }
                },

            },

        }
    },

    created() {


    },

    watch: {

      'show': {
        immediate: true,
        handler(value) {
          if(value) {
            this.initialize();
          }
        }
      }

    },

    mounted() {

    },

    methods: {

        setAnnotation(){
          if(this.bundleAttributeValue === null){
            this.stats.options = Object.assign(this.stats.options, {annotations: {yaxis: []}});
          }else{
            this.stats.options = Object.assign(this.stats.options, {annotations: {
              yaxis: [
                      {  y: this.bundleAttributeValue,
                        borderColor: '#0b6a89',
                        label: {
                          borderColor: '#0b6a89',
                          style: {
                            color: '#fff',
                            background: '#0b6a89'
                          },
                        } 
                      }              
                    ]
            }}); 
          }
        },

        setBundleAttributeValue(attributeName){
          const attribute = this.bundle.attributesDetails.find(el => el.attribute.name === attributeName);
          if(!attribute){
            this.bundleAttributeValue = 0;
          }else{
            if(attribute.attribute.isWritable && attribute.attribute.pivot.override){
              this.bundleAttributeValue = attribute.attribute.pivot.override;
            }else{
              this.bundleAttributeValue = attribute.attribute.pivot.value;
            }
          }
        },

        onChangeType(val) {

          this.isLoading = true;
          const series = [];
            series.push({
                  name: this.$t('Multiscan'),
                  data: Object.values(this.multiscanData[val]) || [],
                  color: '#056BF6'
                });
          
            series.push({
                  name: this.$t('Measurement'),
                  data: Object.values(this.measurementData[val]) || [],
                  color: '#ff0000'
                  
                });
          this.stats.series = cloneDeep(series);
              this.setBundleAttributeValue(val);
              this.setAnnotation();
          this.isLoading = false;

        },

        initialize() {

          let bundleId = this.bundle.id;
          this.axios
            .get(this.$config.api + `/measurements/${bundleId}/countOfDifferences`)
            .then((res) => {
              
                this.statsData = res.data;
                if(!res.data.history) return;
                for(const [key, value] of Object.entries(res.data.history)){
                  let multiscanValues, measurementValues = [];
                  if(Array.isArray(value)){
                    multiscanValues = value.filter(item => item.origin === 'multiscan').map(item => [item.created_at, item.value]);
                    measurementValues = value.filter(item => item.origin === 'measurement').map(item => [item.created_at, item.value]);
                  }
                  
                  if(!multiscanValues || !multiscanValues.length){
                    multiscanValues = [];
                  }

                  this.multiscanData = Object.assign(this.multiscanData, {[key]: multiscanValues});

                  if(!measurementValues || !measurementValues.length){
                    measurementValues = [];
                  }
                  this.measurementData = Object.assign(this.measurementData, {[key]: measurementValues})
                } 

              

              this.onChangeType('width');

            }).catch(err => {
              console.error(err);
            }); 
          
        },


    }


}

</script>

<style lang="scss" scoped>

  .dashboard {

    .statsTotal {
      font-size: 2.6rem;
      line-height: 1;
      font-weight: 600;
      position: relative;
      text-align: center;
    }
    .statsPercent {
      text-align: center;
      padding: 10px 0 0 0;
    }

    @media (max-width: 768px) {
      .statsTotal {
        font-size: 24px;
      }
    }

    ::v-deep .apexcharts-toolbar {
      z-index: 5;
    }

    .small-box {
      min-width: 160px;
    }
  }
</style>
